interface DataObject {
    [key: string]: any;
}

function findClosestIndex(
    arr: DataObject[],
    target: DataObject,
    priority: DataObject | null = null
): string {
    const result = useReduce(
        arr,
        (closest: any, variant: any, index: any) => {
            const items = variant?.items;

            // Calculate the number of matches with the target object
            const targetMatches = useFilter(items, (item) => {
                return target[item.name] && target[item.name] === item.value;
            }).length;

            let priorityMatches = 0;
            if (priority) {
                // Calculate the number of matches with the priority object
                priorityMatches = useFilter(items, (item) => {
                    return priority[item.name] && priority[item.name] === item.value;
                }).length;

                // Determine the overall score based on both target and priority matches
            }
            const totalScore = targetMatches + priorityMatches * 5; // Give higher weight to priority matches

            // If the current variant has a better score, update the closest variant
            if (!closest || totalScore > closest.score) {
                return { index, score: totalScore, id: variant.id };
            }

            return closest;
        },
        { index: 0, score: 0, id: 0 }
    );
    return result.id;
}

export default findClosestIndex;
